<template>
  <div class="confirmation-page">
    <div class="confirmation-box">
      <h1>Merci pour votre commande !</h1>
      <p class="check-icon">✅</p>
      <p class="message">Un e-mail de confirmation a été envoyé à <strong>{{ userEmail }}</strong>.</p>
      <p>Vous recevrez vos articles dans un délai de 48h à 72h.</p>
      <router-link to="/" class="home-link">Retour à l'accueil</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderConfirmationPage',
  data() {
    return {
      userEmail: ''
    }
  },
  mounted() {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.email) {
      this.userEmail = user.email;
    }
  }
};
</script>

<style scoped>
/* ====== MODE CLAIR PAR DÉFAUT ====== */
.confirmation-page {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f2f6f9;
}

.confirmation-box {
  background: white;
  padding: 40px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 0 20px rgba(0,0,0,0.1);
  max-width: 500px;
}

.confirmation-box h1 {
  color: #28a745;
  margin-bottom: 20px;
}

.check-icon {
  font-size: 48px;
  margin-bottom: 10px;
}

.message {
  margin-bottom: 20px;
  font-size: 18px;
  color: #333;
}

.home-link {
  display: inline-block;
  margin-top: 15px;
  padding: 10px 20px;
  background-color: #28a745;
  color: white;
  text-decoration: none;
  border-radius: 8px;
  font-weight: bold;
  transition: background-color 0.3s;
}

.home-link:hover {
  background-color: #218838;
}

/* ====== MODE SOMBRE AUTOMATIQUE ====== */
@media (prefers-color-scheme: dark) {
  .confirmation-page {
    background-color: #121212;
  }

  .confirmation-box {
    background: #1e1e1e;
    box-shadow: 0 0 15px rgba(255,255,255,0.05);
  }

  .confirmation-box h1 {
    color: #4cd964; /* Vert doux lumineux */
  }

  .message {
    color: #e0e0e0;
  }

  .home-link {
    background-color: #078679;
    color: #fff;
  }

  .home-link:hover {
    background-color: #1ea590;
  }
}
</style>
